import "../css/blockimage.css";
import { motion } from "framer-motion";
import line1 from "../img/line1.png";
import line2 from "../img/line2.png";

function BlockRightImage(props) {
  return (
    <div className="wrapper-blockimage wrapper-rightimage">
      <div className="layout8">
        <div className="content padding">
          <motion.div
            className="lcontent"
            initial={{ y: 200, opacity: 0 }}
            whileInView={{
              y: 0,
              opacity: 1,
              transition: {
                type: "spring",
                stiffness: 200,
              },
            }}
          >
            {props.content}
          </motion.div>
        </div>
        <div>
          <img className="rounded-2xl" src={props.src} alt={props.alt}></img>
        </div>
      </div>
 


    </div>
  );
}

export default BlockRightImage;
